module.exports = __webpack_public_path__ + "media/images/pages/fcr/doctor-3-37dfb11c8faf9d33774cff0c735f5b30.png";